import { splitAccessorPath } from '../../../core/utils/accessors/split-accessor-path.js';
import type { DataTableRowData } from '../public.api.js';

/**
 * This function converts a JSONpath like string to an accessor function.
 * @internal
 */
export function makeAccessorFunction<TData extends DataTableRowData, TValue>(
  accessor: string,
): (row: TData) => TValue {
  const accessPath = splitAccessorPath(accessor);

  return function (row: TData) {
    let currentObj = row;
    for (const accessPathPart of accessPath) {
      // oxlint-disable-next-line typescript/no-explicit-any
      currentObj = ((currentObj as any) ?? {})[accessPathPart];
    }

    return currentObj as unknown as TValue;
  };
}
